import { render, staticRenderFns } from "./SidebarNodesList.vue?vue&type=template&id=fa8b4136"
import script from "./SidebarNodesList.vue?vue&type=script&lang=js"
export * from "./SidebarNodesList.vue?vue&type=script&lang=js"
import style0 from "./SidebarNodesList.vue?vue&type=style&index=0&id=fa8b4136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports